import React from 'react'
import ClickAwayListener from 'react-click-away-listener'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mote_primary } from '@mote/config/defaults/colors'
import { useKeyPress } from '@mote/helpers'
import { KeyboardKey } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'

export const EditorSaveToMotebookDialog = ({ onClose, onSave }) => {
  const [moteName, setMoteName] = React.useState('')

  useKeyPress(KeyboardKey.Escape, onClose)

  function handleMoteNameChange(event) {
    setMoteName(event.target.value)
  }

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Root>
        <Backdrop onClick={onClose} />
        <Content>
          <Title>
            Save to{' '}
            <Text fontWeight={400} color={mote_primary}>
              mote
            </Text>
            book
          </Title>
          <Input
            type='text'
            placeholder='Enter name'
            value={moteName}
            onChange={handleMoteNameChange}
          />
          <ButtonContainer>
            <Button
              isDisabled={!moteName}
              onClick={_ => onSave(moteName)}
              text={'Save'}
            />
          </ButtonContainer>
        </Content>
      </Root>
    </ClickAwayListener>
  )
}

const Root = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: #ffffff;
  opacity: 0.75;
`
const Content = styled.div`
  display: flex;
  position: relative;
  z-index: 20;
  padding: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  background-color: #ffffff;
  flex-direction: column;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e5e7eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  max-width: 80%;
`

const Title = styled.div`
  font-size: 1.125rem;
  line-height: 1.75rem;
  text-align: center;
`

const Input = styled.input`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  align-self: center;
  width: 80%;
  height: 2.5rem;
  border-radius: 0.25rem;
  border-width: 1px;
`

const ButtonContainer = styled.div`
  align-self: center;
`

EditorSaveToMotebookDialog.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
